import { IAttachment } from '@app/models/Attachment'
import { AttachmentType, ImageSize } from '@app/models/enums'
import * as React from 'react'

interface IImageProps {
  alt?: string
  className?: string
  defaultImageUrl?: string
  height?: number
  image: IAttachment | undefined
  onClick?: () => void
  size?: ImageSize
  style?: React.CSSProperties
  width?: number
}

export default class Image extends React.PureComponent<IImageProps> {
  public render() {
    let imageSrc: string | undefined
    let altText = this.props.alt

    const defaultImageUrl =
      this.props.defaultImageUrl || '/images/default-image.png'

    if (this.props.image) {
      const image = this.props.image

      if (
        image.type !== AttachmentType.Photo &&
        image.type !== AttachmentType.MainPhoto
      ) {
        imageSrc = defaultImageUrl
      }

      if (this.props.size && image.availableSizes) {
        imageSrc = image.getImageUrl(this.props.size)
      } else {
        imageSrc = image.getUrl()
      }

      if (!altText) {
        altText = this.props.image.title
      }
    } else {
      imageSrc = defaultImageUrl
    }

    return (
      <img
        alt={altText}
        className={this.props.className}
        height={this.props.height}
        onClick={this.props.onClick}
        src={imageSrc}
        style={this.props.style}
        width={this.props.width}
      />
    )
  }
}
